// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AppPlatform,
  AppType,
} from "./types";

export default {
  appId: __t.string(),
  displayName: __t.option(__t.string()),
  description: __t.option(__t.string()),
  executablePath: __t.option(__t.string()),
  get platform() {
    return __t.option(AppPlatform);
  },
  get appType() {
    return __t.option(AppType);
  },
};
